import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../Shared/shared.module';
import { WhatsappTemplateComponent } from './whatsapp-template/whatsapp-template.component';
import { WhatsappInboxComponent } from './whatsapp-inbox/whatsapp-inbox.component';

// WhatsApp pages routed from two places: Notification (/notification/whatsapptemplate, /notification/whatsapp-inbox)
// and Marketing → Whatsapp (/marketing/whatsapp/template, /marketing/whatsapp/whatsapp-inbox). A component can only be
// declared once, so both lazy modules import this one instead of declaring them.
@NgModule({
  declarations: [WhatsappTemplateComponent, WhatsappInboxComponent],
  imports: [CommonModule, SharedModule],
  exports: [WhatsappTemplateComponent, WhatsappInboxComponent]
})
export class WhatsappPagesModule { }
